
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { FindGroupByRefResponse, SearchApi } from '@/api/SearchApi';
import { first, forEach } from 'lodash';
import { is_number } from '@/config/functions';

@Component
export default class SearchInput extends Vue {
   @Prop({ type: Boolean, default: false }) with_archive!: boolean;
   @Prop({ type: String }) placeholder!: string;
   @Prop({ type: String, default: 'group' }) type!: 'group' | 'activity';

   searchValue: string = '';
   searchHints: any = {};

   hints: any[] = [];

   keyPressEnter() {
      if (this.type == 'group' && is_number(this.searchValue)) {
         this.$store.commit('showLoading');
         SearchApi.findGroupByRef({ q: this.searchValue })
            .then(result => {
               this.searchHints = result;

               setTimeout(() => {
                  const f = first(this.hints) as any;
                  if (f) {
                     this.$router.push(f.to);
                  }
               }, 50);
            })
            .finally(() => {
               this.$store.commit('hideLoading');
            });
      }
   }

   @Watch('searchValue', { immediate: true })
   onChangeSearch(q: string) {
      this.searchHints = [];

      if (q.length >= 3) {
         if (this.type == 'group') {
            SearchApi.findGroupByRef({ q }).then(result => {
               this.searchHints = result;
            });
         }

         if (this.type == 'activity') {
            SearchApi.findActivity({ q, archive: this.with_archive }).then(result => {
               this.searchHints = result;
            });
         }
      }
   }

   @Watch('searchHints', { immediate: true })
   onChangeSearchHints(searchHints: FindGroupByRefResponse) {
      this.hints = [];

      forEach(searchHints, (data, key) => {
         if (Object.keys(searchHints).length > 1 && this.hints.length) {
            this.hints.push({ divider: true });
         }

         this.hints.push(
            ...data
               .map(item => {
                  if (key == 'lead guests') {
                     return {
                        name: item?.o_lead_guest,
                        to: { name: 'order.edit', params: { id: item.o_id } },
                     };
                  }

                  if (key == 'Activities') {
                     return {
                        name: item?.o_name,
                        to: { name: 'settings:activity.edit', params: { id: item.o_id } },
                     };
                  }

                  if (key == 'Suppliers') {
                     return {
                        name: item?.o_name,
                        to: { name: 'settings:supplier.edit', params: { id: item.o_id } },
                     };
                  }
               })
               .filter(item => item)
         );
      });
   }
}
